import React from 'react';

const Footer = () => {
  return (
    <footer className="site-footer">
      <p>Powered by TCN</p>
    </footer>
  );
};

export default Footer;
